import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useState} from "react";
import formatPrice from "../../utils/format-price";
import Hint from "../ui/hint/hint";

const defaultText = 'В офисе';

function Step4({number, services}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const setCarDeliveryLocation = useStore((state) => state.setCarDeliveryLocation)

    const getCurrentValue = () => {
        if (carDeliveryLocation) {
            const location = services.filter((service) => service.caraddonid === carDeliveryLocation);
            if (location && location[0]) {
                return location[0].caraddonsitename;
            }
        }
        return defaultText;
    }
    if (!services) {
        return null;
    }

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            Место подачи авто
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.locations}>
                        <div className={styles.location} onClick={() => setCarDeliveryLocation(null)}>
                            <div className={`${styles.checkbox} ${!carDeliveryLocation && styles.checked}`}/>
                            <span className='p-small-size'>{defaultText}</span>
                        </div>
                        {
                            services.map((item) => {
                                if (item.caraddonsitegroup === 'Место подачи автомобиля') {
                                    const price = parseInt(item.caraddonprice);
                                    const ot = item.caraddonsitename === 'В пределах города' ? true : false;
                                    if (price > 0) {
                                        return (<div key={item.caraddonid} className={styles.location}
                                                     onClick={() => setCarDeliveryLocation(item.caraddonid)}>
                                            <div
                                                className={`${styles.checkbox} ${carDeliveryLocation === item.caraddonid && styles.checked}`}/>
                                            <span className={`${styles.heading} p-small-size`}>
                                            {item.caraddonsitename}
                                                {!!price && (` (${ot?'от ':'+'}${formatPrice(price)})`)}
                                                {
                                                    !!item.caraddonsitedescr && !!item.caraddonsitedescr.length && (
                                                        <Hint text={item.caraddonsitedescr}/>)
                                                }
                                        </span>
                                        </div>)
                                    }
                                }
                                return null;
                            })
                        }
                    </div>
                </div>
            )
        }

    </div>);
}

export default Step4;